import Http from '@/services/Http';

const path = 'organizations';
const client = new Http(path);

client.list = () => client.get();

client.listOnwerOrganizations = () =>
  client.get('', { 'filter[is_owner]': true, extended: true });

export default client;
